import { Pipe, PipeTransform } from '@angular/core';
import { Field } from '../../_models/field';

@Pipe({ name: 'fieldQueryFilter' })

export class FieldQueryFilterPipe implements PipeTransform {
  transform(fields: Field[], queryText: string): any[] {
    if (!fields) return [];
    if (!queryText) return fields;
    queryText = queryText.trim().toLowerCase();
    return fields.filter(field => {
      if (field.fieldName.toLowerCase().includes(queryText)) {
        return field;
      }
    });
  }
}
